import * as React from "react";

export interface State {}

export interface Props {
  value: boolean;
}

export default class TickBox extends React.Component<Props, State> {
  render() {
    const { value } = this.props;
    const iconType = value ? "check" : "close";

    return iconType === "check" ? (
      <i className="fas fa-check-square tick-box-checked"></i>
    ) : (
      <span></span>
    );
  }
}
